<template>
  <div class="input-group ui-desplazador-fecha">
    <a class="btn btn-white input-group-addon" @click="gotoFecha(-1)">
      <i class="far fa-chevron-left"></i>
    </a>
    <input-fecha-hora
      v-model="localValue"
      :icon="false"
      :fixed-width="false"
      :position="positionDatepicker"
    />
    <a class="btn btn-white input-group-addon" @click="gotoFecha(1)">
      <i class="far fa-chevron-right"></i>
    </a>
  </div>
</template>

<script>
/**
 * OJO!!!!! No funciona bien!!!!! Solo funciona si le pasamos un value y usamos el tema
 * de redirección que tiene el componente.
 * ¡¡¡ No funciona con v-model !!!! Devuelve mal las fechas cuando seleccionas
 * Un componente con un selector de fecha y flechas de siguiente y anterior
 * para avanzar o retroceder entre fechas
 */
import { addDays } from 'date-fns';
import { remoteScript } from '../../libs/http';
import { dateToLocaleDateString, onlyISODate } from '../../libs/dates';
import Overlay from '../../libs/cifra/overlay';

export default {
  props: {
    value: { type: String, required: true },
    redirectUrl: { type: String, default: null },
    remote: { type: Boolean, default: false },
    positionDatepicker: { type: String, default: 'bottom left' },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    fechaDisplay() {
      return dateToLocaleDateString(new Date(this.localValue));
    },
  },
  watch: {
    localValue(newValue) {
      this.$emit('input', newValue);
      if (this.redirectUrl) {
        const sep = this.redirectUrl.includes('?') ? '&' : '?';
        const url = `${this.redirectUrl}${sep}fecha=${this.fechaDisplay}`;
        this.redirect(url);
      }
    },
    value() {
      this.localValue = this.value;
    },
  },
  methods: {
    gotoFecha(avance) {
      const actual = new Date(this.localValue);
      this.localValue = onlyISODate(addDays(actual, avance));
    },
    redirect(url) {
      this.overlay = new Overlay(document.getElementsByTagName('body')[0]);
      this.overlay.show();
      if (this.remote) {
        remoteScript(url).finally(() => {
          this.overlay.hide();
        });
      } else {
        window.location = url;
      }
    },
  },
  // Realmente creo que esto no sirve para nada
  destroy() {
    if (this.overlay) {
      this.overlay.hide();
    }
  },
};
</script>
